import { render, staticRenderFns } from "./DownloadsLoader.vue?vue&type=template&id=02f58a76&"
import script from "./DownloadsLoader.vue?vue&type=script&lang=js&"
export * from "./DownloadsLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports